/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateSentenceRequest
 */
export interface CreateSentenceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSentenceRequest
     */
    text?: string;
}

/**
 * Check if a given object implements the CreateSentenceRequest interface.
 */
export function instanceOfCreateSentenceRequest(value: object): boolean {
    return true;
}

export function CreateSentenceRequestFromJSON(json: any): CreateSentenceRequest {
    return CreateSentenceRequestFromJSONTyped(json, false);
}

export function CreateSentenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSentenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function CreateSentenceRequestToJSON(value?: CreateSentenceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'text': value['text'],
    };
}

